<form [formGroup]="form"
      (submit)="formSubmit()"
      [class.submitted]="submitSuccess">
  <h2 *ngIf="texts.title"
      class="title"
      [textContent]="texts.title"></h2>
  <div *ngIf="texts?.description"
       class="description"
       [innerHTML]="texts.description"></div>

  <div class="form-container">
    <fieldset class="name">
      <label>
        <span class="label"
              *ngIf="texts.fields.name.label"
              [textContent]="texts.fields.name.label"></span>
        <input formControlName="name"
               type="text"
               [placeholder]="texts.fields.name.placeholder"/>
      </label>

      <div class="error-txt"
           *ngIf="isFieldInvalid('name')">
      <span *ngIf="form.controls['name'].hasError('required')"
            [textContent]="texts.fields.name.error_required"></span>
        <span *ngIf="form.controls['name'].hasError('maxLength')"
              [textContent]="texts.fields.name.error_max_length"></span>
        <span *ngIf="form.controls['name'].hasError('server')"
              [textContent]="form.controls['name'].getError('server')"></span>
      </div>
    </fieldset>
    <fieldset class="emailaddress">
      <label>
      <span class="label"
            *ngIf="texts.fields.emailaddress.label"
            [textContent]="texts.fields.emailaddress.label"></span>
        <input formControlName="emailaddress"
               type="email"
               [placeholder]="texts.fields.emailaddress.placeholder"/>
      </label>

      <div class="error-txt"
           *ngIf="isFieldInvalid('emailaddress')">
      <span *ngIf="form.controls['emailaddress'].hasError('required')"
            [textContent]="texts.fields.emailaddress.error_required"></span>
        <span *ngIf="form.controls['emailaddress'].hasError('email')"
              [textContent]="texts.fields.emailaddress.error_invalid_email"></span>
        <span *ngIf="form.controls['emailaddress'].hasError('server')"
              [textContent]="form.controls['emailaddress'].getError('server')"></span>
      </div>
    </fieldset>
    <fieldset class="subject">
      <label>
        <span class="label"
              *ngIf="texts.fields.subject.label"
              [textContent]="texts.fields.subject.label"></span>
        <input formControlName="subject"
               type="text"
               [placeholder]="texts.fields.subject.placeholder"/>
      </label>

      <div class="error-txt"
           *ngIf="isFieldInvalid('subject')">
      <span *ngIf="form.controls['subject'].hasError('maxLength')"
            [textContent]="texts.fields.name.error_max_length"></span>
        <span *ngIf="form.controls['subject'].hasError('server')"
              [textContent]="form.controls['subject'].getError('server')"></span>
      </div>
    </fieldset>
    <fieldset class="body">
      <label>
        <span class="label"
              *ngIf="texts.fields.body.label"
              [textContent]="texts.fields.body.label"></span>
        <textarea formControlName="body"
                  [placeholder]="texts.fields.body.placeholder"></textarea>
      </label>

      <div class="error-txt"
           *ngIf="isFieldInvalid('body')">
      <span *ngIf="form.controls['body'].hasError('required')"
            [textContent]="texts.fields.body.error_required"></span>

        <span *ngIf="form.controls['body'].hasError('server')"
              [textContent]="form.controls['body'].getError('server')"></span>
      </div>
    </fieldset>
    <div class="submit-container">
      <button type="submit"
              class="btn"
              [textContent]="texts.submit"></button>
    </div>

    <div class="error-txt" *ngIf="serverErrors?.length">
      <span *ngFor="let error of serverErrors" [textContent]="error"></span>
    </div>
  </div>
</form>

<div *ngIf="submitSuccess"
     class="submit-success">
  <div>
    <h2 class="title"
        [textContent]="texts.message_sent_text"></h2>

    <button (click)="submitNewMessage()"
            class="btn"
            [textContent]="texts.new_message"></button>
  </div>

</div>
